import dayjs from 'dayjs'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { httpService } from '@/service/http.service'
import type { Feed } from '@/types'

export const useAlertStore = defineStore('alerts', () => {
  const alerts = ref<Feed[]>([])
  const lastUpdateTime = ref<dayjs.Dayjs | null>(null)

  async function fetchAlerts() {
    try {
      alerts.value = await httpService.infoboards.infoboardsPublicMessagesList({
        type: 'alert'
      })
      lastUpdateTime.value = dayjs()
    } catch {
      // console.log(err)
    }
  }

  return {
    alerts,
    lastUpdateTime,
    fetchAlerts
  }
})
